import React from 'react';
import {videos} from './mediaBundle';
import AcidAnswer from './AcidAnswer';

export default [
    {
        video: videos.video1,
        preview: require('./assets/scenarios/scenario1_preview.jpg'),
        question: 'When someone is being mean, that person could be bullying.',
        fact: true,
        secondQuestion: 'What else describes a bullying incident?:',
        answers: [
            {
                text:
                    'Everyone is having fun, no one is getting hurt, and everyone is participating equally',
                error: 'This is “Teasing”.',
            },
            {
                text:
                    'Someone is being hurt on purpose, it’s a reaction to a strong feeling, does not happen regularly',
                error: 'This is a “Mean Moment”.',
            },
            {
                text:
                    'No one is having fun, there’s a possible solution to the disagreement, there’s an equal balance of power',
                error: 'This is a “Conflict”.',
            },
            {
                text:
                    'Someone is being hurt on purpose, there is an imbalance of power, it happens more than once over a period of time',
                right: true,
            },
        ],
        notes: [
            <AcidAnswer />,
            'Bullying is different from just playing around or peer conflict, or even a mean moment. It occurs when a student, or group of students, repeatedly hurt or humiliate another student. It causes lasting harm and can negatively affect the entire school culture.',
        ],
    },
    {
        video: videos.video2,
        preview: require('./assets/scenarios/scenario2_preview.jpg'),
        question: 'Everybody plays a part in bullying',
        fact: true,
        secondQuestion:
            'If there is an incident of bullying in your school, this is true:',
        answers: [
            {
                text: 'If you ignore it, it probably won’t happen again',
                error:
                    'Actually, the opposite is true. Bullying behavior thrives on an audience, even if the audience seems to not pay attention.',
            },
            {
                text: 'You have to accept that the bully runs the school',
                error:
                    'You don’t have to accept that. As a matter of fact, every student has a right to be safe and to learn. Together you can make a safe and creative environment where anything is possible.',
            },
            {
                text:
                    'Everybody is responsible for the act of cruelty – including you, the teachers, and the principal',
                right: true,
            },
            {
                text:
                    'You have the same potential for learning than you would if your school didn’t have bullying',
                error:
                    'Unfortunately, schools with high rates of bullying are more likely to have lower rates of attendance and achievement scores. Also, there are theories that bullying in schools limits critical thinking and creative decision-making.',
            },
        ],
        notes: [
            `<b>Yes!!</b> Bullying is not a private matter. It’s not a conflict between two people. Bullying is about one person using one’s power to hurt or harm others, and this affects the whole school.`,
            `Power can come from physical or social advantage, and an audience that accepts bullying reinforces that advantage. Bullying is a social injustice that only exists when people in the environment allow it.`,
        ],
    },
    {
        video: videos.video3,
        preview: require('./assets/scenarios/scenario3_preview.jpg'),
        question: 'Cyberbullying can happen anonymously',
        fact: true,
        secondQuestion: 'Cyberbullying also<br/>can be:',
        answers: [
            {
                text: 'Derogatory or<br/>threatening texts',
                error:
                    'Yes! Even though they are words, this is considered <b>verbal bullying</b>. Threats are serious, and those making them should be held accountable. But there’s an even better answer.',
            },
            {
                text: 'Using social media<br/>to spread rumors',
                error:
                    'Yes! Spreading rumors is a form of <b>social bullying</b>. But there’s an even better answer.',
            },
            {
                text: 'Posting embarrassing<br/>pictures without permission',
                error:
                    'Yes! Humiliation is a form of <b>social bullying</b>. But there’s an even better answer.',
            },
            {text: 'All of the above', right: true},
        ],
        notes: [
            `<b>Correct!!</b> Anonymously means without any name acknowledged, and yes, cyberbullying can happen that way, which is one of the reasons why cyberbullying can be more damaging.`,
            `But that doesn’t mean the bullies are protected, it is possible for law enforcement and school administrators to find out where they are; and it is up to students to speak up and write supportive, kind words in return.`,
        ],
    },
    {
        video: videos.video4,
        preview: require('./assets/scenarios/scenario4_preview.jpg'),
        question: 'Bullying is a part of growing up',
        fact: false,
        secondQuestion: 'Being bullied at school…',
        answers: [
            {
                text: 'Builds character',
                error:
                    'No! It feels bad and it’s never okay. However, creating or supporting a climate of no-bullying in your school and standing up to bullying can build character.',
            },
            {
                text: 'Teaches you about the “real” world',
                error:
                    'No! It’s not normal or healthy to repeatedly harm someone, whether in school, home, or work.',
            },
            {
                text: 'Is acceptable if adults look the other way',
                error:
                    "No! Sometimes it seems like it's acceptable and part of growing up because adults see it or hear about it and don’t take action against it. Just remember, they might not know that bullying is a social illness and that it needs to be treated. Find an adult who you can trust to talk to.",
            },
            {text: 'Is inappropriate and goes against social norms', right: true},
        ],
        notes: [
            `<b>Right!! One-third</b> of students say they have either bullied someone or have been bullied. Bullying is not healthy behavior.`,
            `Did you know that research shows that bullies are four times more likely to have criminal records by the time they’re in their mid-20s? And those who have been bullied appear to have higher rates of depression and anxiety? That’s not “just a part of growing up”.`,
        ],
    },
    {
        video: videos.video5,
        preview: require('./assets/scenarios/scenario5_preview.jpg'),
        question: 'There’s not much you can do about bullying so don’t get involved.',
        fact: false,
        secondQuestion:
            'What percentage of peers do you think are involved in bullying episodes, either as contributors or observers?',
        answers: [
            {text: '10% of the time ', error: ''},
            {text: '25% of the time', error: ''},
            {text: '50% of the time', error: ''},
            {text: '85% of the time', right: true},
        ],
        notes: [
            `<b>Correct!!</b> Did you know that most bullying occurs in front of peers because bullies like an audience? As a result, bystanders play an important role in preventing bullying in schools. In fact, research indicates that bystanders can stop bullying within ten seconds over half the time.`,
        ],
    },
    {
        video: videos.video6,
        preview: require('./assets/scenarios/scenario6_preview.jpg'),
        question: 'Stick with the bullies so you’ll be safe and more popular.',
        fact: false,
        secondQuestion: 'Those who bully other kids are more likely to:',
        answers: [
            {text: 'Care about friends and treat them with respect', error: ''},
            {
                text: 'Get into fights, use alcohol and drugs, and drop out of school.',
                right: true,
            },
            {text: 'Be voted “Class President”', error: ''},
            {text: 'Achieve academic success', error: ''},
        ],
        notes: [
            `<b>Yes!!</b> According to <i>stopbullying.gov</i>, kids bully other kids for many reasons. They may want to copy their friends, think bullying will help them fit in, and think they are better than the kids they are bullying.`,
            `But bullying or being a bystander to bullying doesn’t make you safe. Did you know that harassment and bullying have been linked to 75% of school-shooting incidents?`,
        ],
    },
];
